
export const authenticateUser = async (email: string, password: string) => {
  const response = await fetch('https://api.prosperasistemas.com/v1/usuario/autenticar', {
    method: 'POST',
    headers: {
      'Authorization': 'Basic YTRkOGU2MTgtMzkxNy00MGVjLTg4NGEtNWQ3ODNlZmE0ODFjOg==',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      senha: password
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
